<template>
  <inventoryProductsCategoriesForm :typeEndPoint="'inventoryProductsCategoriesForm'" :dataParams="{}" />
</template>
<script>
import inventoryProductsCategoriesForm from '@/components/modules/inventory/products/categories/form'
export default {
  name: 'inventoryProductsCategories',
  components: {
    inventoryProductsCategoriesForm
  },
  mounted () {
    console.log(this.$route.params)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/inventory/products/categories/create.vue